export class AuthoritativeRevalidationRequiredError extends Error {
    idempotencyKey;
    constructor(idempotencyKey) {
        super(`Authoritative command ${idempotencyKey} requires fresh state revalidation`);
        this.name = "AuthoritativeRevalidationRequiredError";
        this.idempotencyKey = idempotencyKey;
    }
}
export class AuthoritativeMirror {
    kind = "authoritative-mirror";
    #apply;
    #execute;
    #staleAfterMs;
    #applied = new Set();
    #commands = new Map();
    #snapshot;
    constructor(options) {
        if (!Number.isInteger(options.staleAfterMs) || options.staleAfterMs <= 0) {
            throw new RangeError("Authoritative mirror staleAfterMs must be a positive integer");
        }
        this.#apply = options.apply;
        this.#execute = options.execute;
        this.#staleAfterMs = options.staleAfterMs;
    }
    async applyDelta(delta, context) {
        if (this.#applied.has(delta.id))
            return { applied: false };
        const observedAt = parseDate(context.now, "snapshot observation time");
        const snapshot = {
            observedAt: context.now,
            staleAt: new Date(observedAt + this.#staleAfterMs).toISOString(),
            value: delta.payload,
        };
        await this.#apply(snapshot, delta);
        this.#snapshot = snapshot;
        this.#applied.add(delta.id);
        return { applied: true };
    }
    snapshot() {
        return this.#snapshot;
    }
    isStale(now) {
        return this.#snapshot === undefined || parseDate(now, "current time") >= Date.parse(this.#snapshot.staleAt);
    }
    async runCommand(command, options) {
        const existing = this.#commands.get(command.idempotencyKey);
        if (existing !== undefined)
            return await existing;
        if (this.isStale(options.now)) {
            const fresh = options.revalidate === undefined ? false : await options.revalidate();
            if (!fresh)
                throw new AuthoritativeRevalidationRequiredError(command.idempotencyKey);
        }
        const execution = this.#execute(command);
        this.#commands.set(command.idempotencyKey, execution);
        try {
            return await execution;
        }
        catch (error) {
            this.#commands.delete(command.idempotencyKey);
            throw error;
        }
    }
}
function parseDate(value, label) {
    const parsed = Date.parse(value);
    if (!Number.isFinite(parsed))
        throw new RangeError(`Invalid ${label}`);
    return parsed;
}
//# sourceMappingURL=authoritative-mirror.js.map